module.exports = __webpack_public_path__ + "static/media/shane.174b1fe7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/shane.jpg
// module id = 378
// module chunks = 17